module.exports = __webpack_public_path__ + "img/yw-2.84d53e0f.svg";